module.exports = __webpack_public_path__ + "fonts/Inter-Regular.fc49d13.woff";